module.exports = __webpack_public_path__ + "522c6bda.png";